










import { Component, Vue, Watch } from "vue-property-decorator";
import store from "@/vuex/index";
import {
  SideBar,
  AppMain,
  HeaderBar
} from "./components";
@Component({
  components: {
    SideBar,
    AppMain,
    HeaderBar,
  },
})
export default class Home extends Vue {
  public sysName: string = "";
  public collapsed: boolean = false;
  public sysUserName: string = "";
  public sysUserAvatar: string = "";
  public form: {
    name: "";
    region: "";
    date1: "";
    date2: "";
    delivery: false;
    type: null;
    resource: "";
    desc: "";
  };

  public $refs: {
    menuCollapsed: HTMLFormElement;
  };
  created() {
    this.sysUserAvatar = "/static/logo.ico";
  }
  onSubmit() {}

  //折叠导航栏
  public collapse = function () {
    this.collapsed = !this.collapsed;
  };
  public showMenu(i, status) {
    let element: any = this.$refs.menuCollapsed.getElementsByClassName(
      "submenu-hook-" + i
    )[0];
    element.style.display = status ? "block" : "none";
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/homenew/Home.vue